import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { Endpoint, ProjectIdParam } from "@/types"

type PatchEndpointRequest = {
  is_enabled: boolean
}

export const cloudEndpointsApi = createApi({
  reducerPath: "cloudEndpointApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}endpoints`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    endpointGet: build.query<Endpoint | null, ProjectIdParam>({
      query: ({ project_id }) => ({
        url: `${project_id}?limit=1&offset=0`,
      }),
      transformResponse: (res: Endpoint[], _meta, _arg) => {
        return res.length ? res[0] : null
      },
    }),
    endpointsPatch: build.mutation<null, ProjectIdParam & PatchEndpointRequest>(
      {
        query: (req) => ({
          url: req.project_id,
          method: "PATCH",
          body: { is_enabled: req.is_enabled },
        }),
      },
    ),
  }),
})

export const { useEndpointGetQuery, useEndpointsPatchMutation } =
  cloudEndpointsApi
